// extracted by mini-css-extract-plugin
export default {"wrapper":"Page404_wrapper__P29VR","main":"Page404_main__zmCEV","text":"Page404_text__2N3nk","title":"Page404_title__8wDCh","btn":"Page404_btn__89FGB"};